import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { CoreClassroomAdminClassroom, CoreClassroomAdminClassroomState } from "../../../models/CoreClassroomAdminClassroom";
import { RequestState } from "../../../models/RequestState";
import { GetClassroom } from "../../../store/ClassroomAdmin/ClassroomAdminClassroomAction";
import { RootState } from "../../../store/store";
import StatusCode from "../../../util/StatusCode";
import TableVertical from "../../misc/TableVertical";
import * as Helper from '../../../util/Helper';
import { useTranslation } from 'react-i18next';


const ClassroomViewInfo = () => {
    const { t } = useTranslation(['classroomAdmin']);

    const { classroomId } = useParams();
    const dispatch = useDispatch();
    const classroom = useSelector<RootState, RequestState<CoreClassroomAdminClassroom>>(x => x.classroomAdminClassroom.classroom);

    useEffect(() => {
        if (classroomId && classroom.code !== StatusCode.COMPLETE) {
            GetClassroom(classroomId)(dispatch);
        }
    }, [dispatch]);

    const getState = (courseState: CoreClassroomAdminClassroomState) => {
        return `${t('classroomAdmin.state.' + courseState.courseState, { ns: 'classroomAdmin' })} ${t('classroomAdmin.stateInfo.' + courseState.stateInformation, { ns: 'classroomAdmin' })}`
    }

    const renderClassroomInfo = () => {

        let classroomInfo = [];
        if (classroom.code === StatusCode.COMPLETE) {
            const x = classroom.data;
            classroomInfo.push(
                { header: t('classroomAdmin.tableHeader.classroomName', {ns: 'classroomAdmin'}), content: x.classroomName },
                { header: t('classroomAdmin.tableHeader.classroomState', { ns: 'classroomAdmin' }), content: getState(x.state) },
                { header: t('classroomAdmin.tableHeader.synched', { ns: 'classroomAdmin' }), content: Helper.active(x.synched) },
                { header: t('classroomAdmin.tableHeader.orphaned', { ns: 'classroomAdmin' }), content: Helper.active(x.orphaned) },
                { header: t('classroomAdmin.tableHeader.ownerEmail', { ns: 'classroomAdmin' }), content: x.ownerEmail },
                { header: t('classroomAdmin.tableHeader.ownerId', { ns: 'classroomAdmin' }), content: x.ownerId },
                { header: t('classroomAdmin.tableHeader.ownerState', { ns: 'classroomAdmin' }), content: t(`classroomAdmin.ownerState.${x.ownerState}`, {ns: 'classroomAdmin'}) },
                { header: t('classroomAdmin.tableHeader.teacherCount', { ns: 'classroomAdmin' }), content: x.teacherCount },
                { header: t('classroomAdmin.tableHeader.studentCount', { ns: 'classroomAdmin' }), content: x.studentCount },
                { header: t('classroomAdmin.tableHeader.creationTime', { ns: 'classroomAdmin' }), content: Helper.formatDate(x.creationTime) },
                { header: t('classroomAdmin.tableHeader.updateTime', { ns: 'classroomAdmin' }), content: Helper.formatDate(x.updateTime) },
                { header: t('classroomAdmin.tableHeader.descriptionHeading', { ns: 'classroomAdmin' }), content: x.descriptionHeading },
                { header: t('classroomAdmin.tableHeader.section', { ns: 'classroomAdmin' }), content: x.section},
                { header: t('classroomAdmin.tableHeader.subject', { ns: 'classroomAdmin' }), content: x.subject },
                { header: t('classroomAdmin.tableHeader.room', { ns: 'classroomAdmin' }), content: x.room },
                { header: t('classroomAdmin.tableHeader.enrollmentCode', { ns: 'classroomAdmin' }), content: x.enrollmentCode },
                { header: t('classroomAdmin.tableHeader.alternateLink', { ns: 'classroomAdmin' }), content: <a href={x.alternateLink} target="_blank" rel="noreferrer">{x.alternateLink}</a> },
                { header: t('classroomAdmin.tableHeader.guardiansEnabled', { ns: 'classroomAdmin' }), content: Helper.active(x.guardiansEnabled) },
                { header: t('classroomAdmin.tableHeader.activity', { ns: 'classroomAdmin' }), content: x.activity ? <Link to={`/activity/${x.activity.id}/information`}>{x.activity.title}</Link> : null },
                { header: t('classroomAdmin.tableHeader.group', { ns: 'classroomAdmin' }), content: x.group ? <Link to={`/group/${x.group.id}/information`}>{x.group.title}</Link> : null },
                { header: t('classroomAdmin.tableHeader.schoolUnit', { ns: 'classroomAdmin' }), content: x.schoolUnit ? <Link to={`/schoolunit/${x.schoolUnit.id}/information`}>{x.schoolUnit.title}</Link> : null },
            )
        }

        return (
            <TableVertical
                header={t('commonTableHeaders.information', { ns: 'classroomAdmin' })}
                info={classroomInfo}
                error={classroom.code === StatusCode.ERROR}
                searching={classroom.code === StatusCode.PENDING}
            />
        )
    }

    return (<>
        {renderClassroomInfo()}
    </>)
}

export default ClassroomViewInfo;
